import React from 'react';
import { Button, TextField, FormControlLabel, Checkbox, Alert } from '@mui/material';
import ForgetPassword from '../Components/passwordForgotten/PasswordForgotten';

import './Login.css'

import { useState, useContext } from 'react';
import { FirebaseContext } from '../Services/firebase'

export default function Login() {

    const firebase = useContext(FirebaseContext)

    const data = {
        email: '',
        password: ''
    }

    const [loginData, setLoginData] = useState(data)
    const [error, setError] = useState('')

    const handleChange = e => {
        setLoginData({...loginData, [e.target.id]: e.target.value})
    }

    const login = () => {
        firebase.loginUser(loginData.email, loginData.password)
        .then(() => {
            setLoginData({...data})
            window.location.href = "/dashboard"
        })
        .catch(error => {
            setError(error)
            setLoginData({...data})
        })
    }


    const btn = loginData.email === '' || loginData.password === '' ? <Button variant="contained" onClick={login} disabled >Se connecter</Button> : <Button variant="contained" onClick={login}>Se connecter</Button>
        
    //error management
    const errorMsg = error !== '' && <span>{error.message}</span>

    return (
        <div className="mainDiv">
            <img alt="senior" className="seniorImg" src="/senior.jpg"/>
            <div className="loginForm">
                <img alt="logo" src="/logo.png"/>
                { error !== '' ? <Alert style={{marginTop: "2vh"}} severity="error">{errorMsg}</Alert> : null }
                <h1>Se connecter</h1>
                <TextField required fullWidth type="text" id="email" name="email" value={loginData.email} onChange={handleChange} label="Adresse E-mail" variant="outlined"/>
                <TextField required fullWidth type="password" id="password" name="password" value={loginData.password} onChange={handleChange} label="Mot de passe" variant="outlined" margin="normal"/>
                <FormControlLabel style={{placeSelf: "start"}} control={<Checkbox defaultChecked/>} label="Se souvenir de moi" />
                {btn}
                <ForgetPassword/>
            </div>
        </div>
    )
}